import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSmartPrefetch } from './useSmartPrefetch';

/**
 * Auto-prefetch likely next routes based on current location
 * Runs predictive prefetching in the background
 */
export const useRoutePrefetch = () => {
  const location = useLocation();
  const { prefetchRoute } = useSmartPrefetch();

  useEffect(() => {
    // Small delay to avoid blocking initial render
    const timer = setTimeout(() => {
      prefetchRoute(location.pathname);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname, prefetchRoute]);
};
